export type DateTimeLocale = 'zh' | 'zh-HK' | 'en'
export type UniversalDateFormatter = 'DMY' | 'MY' | 'DM' | 'D/M/Y' | 'M/Y' | 'D/M'

export const toDate = (d: string | number | Date) => {
  let date = d

  if (!date) return new Date()
  if (typeof d === 'number') {
    date = new Date(d)
  } else if (typeof d === 'string') {
    if (/\d{8}/.test(d)) {
      const replaceDateStr = d.replace(/^(\d{4})(\d{2})(\d{2})$/, '$1-$2-$3')
      date = new Date(replaceDateStr)
    } else {
      date = new Date(date)
    }
  }

  return date as Date
}

export const dateFormat = (d: string | number | Date, formatter = 'yyyy-MM-dd') => {
  let date = d
  if (typeof date === 'string' || typeof date === 'number') {
    date = new Date(d)
  }
  let o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
  }
  if (/(y+)/.test(formatter)) {
    formatter = formatter.replace(/(y+)/, (_, p1) => ((date as Date).getFullYear() + '').slice(4 - (p1?.length || 0)))
  }
  for (const [k, v] of Object.entries(o)) {
    if (new RegExp('(' + k + ')').test(formatter)) {
      formatter = formatter.replace(new RegExp('(' + k + ')'), (_, p1) => (p1?.length === 1 ? '' + v : ('00' + v).slice(('' + v).length)))
    }
  }
  return formatter
}

export const universalDateFormat = (d: string | number | Date, formatter?: UniversalDateFormatter, locale?: DateTimeLocale) => {
  let date = d
  formatter = formatter || 'DMY'
  locale = locale || Mach.requireModule('Intl')?.getCurrentLocaleInfo?.()?.locale || 'en'
  if (typeof date === 'string' || typeof date === 'number') {
    date = toDate(d)
  }

  const day = date.getDate()
  const month = date.getMonth() + 1
  const year = date.getFullYear()
  const paddedDay = day < 10 ? '0' + day : day
  const paddedMonth = month < 10 ? '0' + month : month

  if (locale === 'zh' || locale === 'zh-HK') {
    switch (formatter) {
      case 'DMY':
        return `${year}年${paddedMonth}月${paddedDay}日`
      case 'MY':
        return `${year}年${paddedMonth}月`
      case 'DM':
        return `${paddedMonth}月${paddedDay}日`
      case 'D/M/Y':
        return `${paddedDay}/${paddedMonth}/${year}`
      case 'M/Y':
        return `${paddedMonth}/${year}`
      case 'D/M':
        return `${paddedDay}/${paddedMonth}`
      default:
        return 'Invalid date format'
    }
  } else {
    const monthNamesEn = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    switch (formatter) {
      case 'DMY':
        return `${paddedDay} ${monthNamesEn[month - 1]} ${year}`
      case 'MY':
        return `${monthNamesEn[month - 1]} ${year}`
      case 'DM':
        return `${paddedDay} ${monthNamesEn[month - 1]}`
      case 'D/M/Y':
        return `${paddedDay}/${paddedMonth}/${year}`
      case 'M/Y':
        return `${monthNamesEn[month - 1]} ${year}`
      case 'D/M':
        return `${paddedDay}/${paddedMonth}`
      default:
        return 'Invalid date format'
    }
  }
}
